module.exports = __webpack_public_path__ + "45597ae2f5c9ed725e803ddc86b54424.jpg";